import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-white border-t border-gray-200 pt-10 pb-6">
      <div className="container mx-auto px-4">

        {/* Footer main content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">

          {/* Company Info */}
          <div className="col-span-1">
            <div className="mb-4">
              <img 
                src="/assets/logo/klm-logo.png" 
                alt="KLM Logo" 
                className="h-16 w-auto"
              />
            </div>
            <p className="text-gray-600 text-sm mb-4">
              Your one-stop shop for Premium Agriculture & Packaging Solutions.
            </p>
            <div className="text-sm text-gray-600 space-y-1">
              <p>📞 <a href="tel:+917995004136 " className="hover:text-blue-600">+91 7995004136 </a></p>
              <p>✉️ <a href="mailto:klmkartsales@gmail.com" className="hover:text-blue-600">klmkartsales@gmail.com</a></p>
            </div>
          </div>

          {/* Shop */}
          <div className="col-span-1">
            <h3 className="text-gray-900 font-medium mb-4">Shop</h3>
            <ul className="space-y-2">
              <li><Link to="/products" className="text-gray-600 hover:text-blue-600 text-sm">All Products</Link></li>
              <li><Link to="/categories" className="text-gray-600 hover:text-blue-600 text-sm">Categories</Link></li>
              <li><Link to="/new-arrivals" className="text-gray-600 hover:text-blue-600 text-sm">New Arrivals</Link></li>
              <li><Link to="/cart" className="text-gray-600 hover:text-blue-600 text-sm">My Cart</Link></li>
            </ul>
          </div>

          {/* Account */}
          <div className="col-span-1">
            <h3 className="text-gray-900 font-medium mb-4">My Account</h3>
            <ul className="space-y-2">
              <li><Link to="/auth" className="text-gray-600 hover:text-blue-600 text-sm">Login / Sign Up</Link></li>
              <li><Link to="/dashboard" className="text-gray-600 hover:text-blue-600 text-sm">Dashboard</Link></li>
              <li><Link to="/orders" className="text-gray-600 hover:text-blue-600 text-sm">My Orders</Link></li>
              <li><Link to="/wishlist" className="text-gray-600 hover:text-blue-600 text-sm">Wishlist</Link></li>
              <li><Link to="/profile" className="text-gray-600 hover:text-blue-600 text-sm">Profile</Link></li>
            </ul>
          </div>

          {/* Help & Policies */}
          <div className="col-span-1">
            <h3 className="text-gray-900 font-medium mb-4">Help & Policies</h3>
            <ul className="space-y-2">
              <li><Link to="/contact" className="text-gray-600 hover:text-blue-600 text-sm">Contact Us</Link></li>
              <li><Link to="/shipping-policy" className="text-gray-600 hover:text-blue-600 text-sm">Shipping Policy</Link></li>
              <li><Link to="/refund-policy" className="text-gray-600 hover:text-blue-600 text-sm">Refund & Cancellation</Link></li>
              <li><Link to="/terms-of-service" className="text-gray-600 hover:text-blue-600 text-sm">Terms & Conditions</Link></li>
              <li><Link to="/privacy-policy" className="text-gray-600 hover:text-blue-600 text-sm">Privacy Policy</Link></li>
            </ul>
          </div>

        </div>

        {/* Payment methods */}
        {/* <div className="border-t border-gray-200 pt-8 mb-8">
          <div className="flex flex-wrap justify-center items-center gap-4">
            <span className="text-gray-500 text-sm">We accept:</span>
            <img src="/assets/payment/Visa_Inc.-Logo.wine.svg" alt="Visa" className="h-8" />
            <img src="/assets/payment/mastercard-svgrepo-com.svg" alt="Mastercard" className="h-8" />
            <img src="/assets/payment/upi-icon.svg" alt="UPI" className="h-8" />
            <img src="/assets/payment/PhonePe-Logo.wine.svg" alt="Phonepe" className="h-14" />
          </div>
        </div> */}

        {/* Copyright */}
        <div className="border-t border-gray-200 pt-6 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} KLMKart. All rights reserved.
          </p>
          <div className="flex space-x-4 mt-4 md:mt-0">
            <Link to="/privacy-policy" className="text-gray-500 hover:text-blue-600 text-sm">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-gray-500 hover:text-blue-600 text-sm">Terms of Service</Link>
            <Link to="/refund-policy" className="text-gray-500 hover:text-blue-600 text-sm">Refund Policy</Link>
            <Link to="/contact" className="text-gray-500 hover:text-blue-600 text-sm">Contact</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;